'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// styled


var _mobxReact = require('mobx-react');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment3 = require('react-day-picker/moment');

var _moment4 = _interopRequireDefault(_moment3);

var _BaseInput = require('../BaseInput');

var _BaseInput2 = _interopRequireDefault(_BaseInput);

var _Fieldset = require('../Fieldset');

var _Fieldset2 = _interopRequireDefault(_Fieldset);

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

var _RuleHint = require('../RuleHint');

var _RuleHint2 = _interopRequireDefault(_RuleHint);

var _rules = require('../Webform/rules');

var _rules2 = _interopRequireDefault(_rules);

var _WebformElement = require('../WebformElement');

var _WebformElement2 = _interopRequireDefault(_WebformElement);

var _WebformUtils = require('../WebformUtils');

var _WebformUtils2 = _interopRequireDefault(_WebformUtils);

var _labelTranslations = require('./labelTranslations');

var _labelTranslations2 = _interopRequireDefault(_labelTranslations);

var _wrapper = require('./styled/wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _overlayWrapper = require('./styled/overlay-wrapper');

var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);

var _overlay = require('./styled/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _dayPicker = require('./styled/day-picker');

var _dayPicker2 = _interopRequireDefault(_dayPicker);

var _validationIcon = require('./styled/validation-icon');

var _validationIcon2 = _interopRequireDefault(_validationIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Date = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Date, _Component);
  (0, _createClass3.default)(Date, null, [{
    key: 'rewriteValue',
    value: function rewriteValue(value) {
      var date = (0, _moment2.default)(value, Date.dateFormat, true);
      return date.format('YYYY-MM-DD');
    }
  }]);

  function Date(props) {
    (0, _classCallCheck3.default)(this, Date);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Date.__proto__ || (0, _getPrototypeOf2.default)(Date)).call(this, props));

    _this.min = props.field['#min'] || props.field['#date_date_min'];
    _this.max = props.field['#max'] || props.field['#date_date_max'];

    _rules2.default.set('date_' + props.field['#webform_key'], {
      rule: function rule(value) {
        var timestamp = (0, _moment2.default)(value, Date.dateFormat, true);
        return _WebformUtils2.default.isEmpty(props.field, value) || timestamp.isValid();
      },
      hint: function hint() {
        return _react2.default.createElement(_RuleHint2.default, {
          key: 'date_' + props.field['#webform_key'],
          hint: _WebformUtils2.default.getCustomValue(props.field, 'dateError', props.settings) || _WebformUtils2.default.getErrorMessage(props.field, '#required_error') || 'Please enter a valid date.'
        });
      },
      shouldValidate: function shouldValidate(field) {
        return field.isBlurred && !_WebformUtils2.default.isEmpty(field, field.getValue());
      }
    });

    _rules2.default.set('date_range_' + props.field['#webform_key'], {
      rule: function rule(value) {
        return _WebformUtils2.default.isEmpty(props.field, value) || _this.calculateDateRange(value).valid;
      },
      hint: function hint(value) {
        var result = _this.calculateDateRange(value);
        var hint = void 0;

        switch (result.type) {
          case 'before':
            hint = _WebformUtils2.default.getCustomValue(props.field, 'dateBeforeError', props.settings) || _WebformUtils2.default.getErrorMessage(props.field, '#required_error') || 'Please enter a date before {{max}}';
            break;
          case 'after':
            hint = _WebformUtils2.default.getCustomValue(props.field, 'dateAfterError', props.settings) || _WebformUtils2.default.getErrorMessage(props.field, '#required_error') || 'Please enter a date after {{min}}';
            break;
          default:
          case 'range':
            hint = _WebformUtils2.default.getCustomValue(props.field, 'dateRangeError', props.settings) || _WebformUtils2.default.getErrorMessage(props.field, '#required_error') || 'Please enter a date between {{min}} and {{max}}';
            break;
        }

        return _react2.default.createElement(_RuleHint2.default, {
          key: 'date_range_' + props.field['#webform_key'],
          hint: hint,
          tokens: {
            value: value,
            min: result.min ? result.min.format(Date.dateFormat) : false,
            max: result.max ? result.max.format(Date.dateFormat) : false
          }
        });
      },
      shouldValidate: function shouldValidate(field) {
        return field.isBlurred && !_WebformUtils2.default.isEmpty(field, field.getValue());
      }
    });

    _this.clickedInside = false;

    _this.state = {
      showOverlay: false,
      selectedDay: (0, _moment2.default)(props.value, Date.dateFormat, true).isValid() ? (0, _moment2.default)(props.value, Date.dateFormat).toDate() : null
    };

    _this.calculateDisabledDates = _this.calculateDisabledDates.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleContainerMouseDown = _this.handleContainerMouseDown.bind(_this);
    _this.handleDayClick = _this.handleDayClick.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Date, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.clickTimeout);
    }
  }, {
    key: 'setRef',
    value: function setRef(ref, el) {
      this[ref] = el;
    }
  }, {
    key: 'getDateRange',
    value: function getDateRange() {
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.dateFormat;

      var minMoment = (0, _moment2.default)(this.min, dateFormat, true);
      var maxMoment = (0, _moment2.default)(this.max, dateFormat, true);

      result.min = minMoment;
      if (!minMoment.isValid()) {
        var _min$split = this.min.split(' '),
            _min$split2 = (0, _slicedToArray3.default)(_min$split, 2),
            amount = _min$split2[0],
            unit = _min$split2[1];

        result.min = (0, _moment2.default)().add(amount, unit);
      }

      result.max = maxMoment;
      if (!maxMoment.isValid()) {
        var _max$split = this.max.split(' '),
            _max$split2 = (0, _slicedToArray3.default)(_max$split, 2),
            _amount = _max$split2[0],
            _unit = _max$split2[1];

        result.max = (0, _moment2.default)().add(_amount, _unit);
      }

      return result;
    }
  }, {
    key: 'getLabelDisplay',
    value: function getLabelDisplay() {
      return this.props.webformElement.getLabelDisplay();
    }
  }, {
    key: 'calculateDateRange',
    value: function calculateDateRange(value) {
      var result = this.getDateRange({
        valid: true
      });

      var timestamp = (0, _moment2.default)(value, Date.dateFormat, true);

      if (this.min && this.max) {
        result.type = 'range';
        result.valid = timestamp.isBetween(result.min, result.max);
      } else if (this.min) {
        result.type = 'after';
        result.valid = timestamp.isAfter(result.min);
      } else if (this.max) {
        result.type = 'before';
        result.valid = timestamp.isBefore(result.max);
      }

      return result;
    }
  }, {
    key: 'calculateDisabledDates',
    value: function calculateDisabledDates(day) {
      var result = this.calculateDateRange((0, _moment2.default)(day).format(Date.dateFormat));
      return !result.valid;
    }
  }, {
    key: 'handleInputBlur',
    value: function handleInputBlur() {
      var showOverlay = this.clickedInside;

      this.setState({ showOverlay: showOverlay });

      // Force input's focus if blur event was caused by clicking on the calendar.
      if (showOverlay) {
        this.props.onFocus();
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus() {
      this.setState({ showOverlay: true });
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      var _this2 = this;

      var value = e.target.value;
      var momentDay = (0, _moment2.default)(value, Date.dateFormat, true);
      var newValue = momentDay.isValid() ? momentDay.format(Date.dateFormat) : value;
      var selectedDay = momentDay.isValid() ? momentDay.toDate() : null;
      this.props.onChange(newValue);
      this.setState({ selectedDay: selectedDay }, function () {
        return selectedDay && _this2.daypicker.showMonth(selectedDay);
      });
    }
  }, {
    key: 'handleContainerMouseDown',
    value: function handleContainerMouseDown() {
      var _this3 = this;

      this.clickedInside = true;
      // The input's onBlur method is called from a queue right after onMouseDown event.
      // setTimeout adds another callback in the queue, but is called later than onBlur event.
      this.clickTimeout = setTimeout(function () {
        return _this3.clickedInside = false;
      }, 0);
    }
  }, {
    key: 'handleDayClick',
    value: function handleDayClick(selectedDay) {
      this.props.onChange((0, _moment2.default)(selectedDay).format(Date.dateFormat));
      this.setState({
        selectedDay: selectedDay,
        showOverlay: false
      });
      this.props.onBlur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          value = _props.value,
          field = _props.field;


      field['#mask'] = _Fieldset2.default.getValue(field, 'mask');
      if (field['#mask'] === false) {
        field['#mask'] = '99/99/9999';
      }

      if (!field['#datepicker']) {
        return _react2.default.createElement(_Input2.default, (0, _extends3.default)({}, this.props, {
          field: field,
          type: this.props.type
        }));
      }

      var DateInput = _react2.default.createElement(_BaseInput2.default, (0, _extends3.default)({}, this.props, {
        field: field,
        type: this.props.type,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        value: value
      }));

      return _react2.default.createElement(
        _wrapper2.default,
        {
          onMouseDown: this.handleContainerMouseDown,
          onBlur: this.handleInputBlur,
          labelDisplay: this.getLabelDisplay(),
          className: 'hrw-input-wrap hrw-date-wrap hrw-label-display-' + this.getLabelDisplay()
        },
        DateInput,
        this.state.showOverlay && _react2.default.createElement(
          _overlayWrapper2.default,
          null,
          _react2.default.createElement(
            _overlay2.default,
            null,
            _react2.default.createElement(_dayPicker2.default, {
              innerRef: function innerRef(el) {
                return _this4.setRef('daypicker', el);
              },
              initialMonth: this.state.selectedDay || undefined,
              onDayClick: this.handleDayClick,
              selectedDays: this.state.selectedDay,
              locale: this.props.locale,
              localeUtils: _moment4.default,
              labels: _labelTranslations2.default[this.props.locale],
              enableOutsideDays: true,
              disabledDays: [this.calculateDisabledDates]
            })
          )
        ),
        _react2.default.createElement(_validationIcon2.default, { success: this.props.webformElement.isSuccess(), className: 'hrw-validation-icon' })
      );
    }
  }]);
  return Date;
}(_react.Component), _class2.meta = {
  validations: [function (el) {
    return 'date_' + el.key;
  }, function (el) {
    return 'date_range_' + el.key;
  }]
}, _class2.propTypes = {
  field: _propTypes2.default.shape({
    '#webform_key': _propTypes2.default.string,
    '#default_value': _propTypes2.default.string,
    '#date_date_min': _propTypes2.default.string,
    '#date_date_max': _propTypes2.default.string,
    '#min': _propTypes2.default.string,
    '#max': _propTypes2.default.string,
    '#mask': _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
    '#dateError': _propTypes2.default.string,
    '#dateRangeError': _propTypes2.default.string,
    '#dateBeforeError': _propTypes2.default.string,
    '#dateAfterError': _propTypes2.default.string,
    '#title_display': _propTypes2.default.string,
    '#datepicker': _propTypes2.default.bool,
    composite_elements: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
  }).isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]).isRequired,
  type: _propTypes2.default.string,
  webformElement: _propTypes2.default.instanceOf(_WebformElement2.default).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func.isRequired,
  settings: _propTypes2.default.shape().isRequired,
  locale: _propTypes2.default.string
}, _class2.defaultProps = {
  locale: 'nl',
  type: 'text',
  onFocus: function onFocus() {}
}, _class2.dateFormat = 'DD/MM/YYYY', _temp)) || _class;

exports.default = Date;